import { useEffect } from 'react'
import { useCallbackEvent } from './use-callback-event'

export const useInterval = (callback: () => void, delay: number | null) => {
  const fn = useCallbackEvent(callback)

  useEffect(() => {
    let intervalId: number | null = null
    const tick = () => fn()
    // Don't schedule if no delay is specified.
    // Note: 0 is a valid value for delay.
    if (delay !== null) {
      intervalId = window.setInterval(tick, delay)
    }

    return () => {
      if (intervalId !== null) {
        window.clearInterval(intervalId)
      }
    }
  }, [delay, fn])
}
